import React, { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  SvgIcon,
} from "@mui/material";
import styles from "./MockGrid.module.scss";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { useNavigate } from "react-router-dom";
import { ILoginResponse } from "../Login/ILogin";
import { listMockExam } from "../../Redux/Slices/MockExam/ListMockExamSlice";
import { decode } from "../../Utils/encodeDecode";
import { listInstructionExamID } from "../../Redux/Slices/Exam/ListinstructionExamIDSlice";
import { addStudentExam } from "../../Redux/Slices/StudentExam/AddStudentExamSlice";
import { clearListExamID } from "../../Redux/Slices/Exam/ListExamIDSlice";
import Mockexamimage from "./Imagemockexampage/MockExamimage.jpg";
import Menus from "../../Components/Menu/Menu";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import { ReactComponent as document_icon } from "../../Assets/Images/document_icon.svg";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const MockexamGrid = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [details, setDetails] = useState<ILoginResponse>({});

  const { data: mockExamSlice } = useAppSelector(
    (state) => state.MockExamSlice
  );
  const Mock: any = mockExamSlice?.data;

  useEffect(() => {
    dispatch(listMockExam());
    const userDetails = decode(sessionStorage.getItem("details"));
    setDetails(userDetails);
  }, []);

  function formatDuration(duration: any) {
    if (!duration) return ""; // Handle empty input gracefully

    return duration
      .replace("minutes", "min")
      .replace("minute", "min")
      .replace("hours", "hr")
      .replace("hour", "hr")
      .replace("seconds", "sec")
      .replace("second", "sec");
  }

  useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);
  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
        ...user,
        index: index + 1,
      }))
    : [];
  return (
    <div className={styles.MockStudentAlingment}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div>
          <div className="DashboardStudent">Mini Mock Exam</div>
          <div className={styles.StudentPractice}>
            Short practice exams with mixed question types
          </div>
        </div>
        <div>
          <Menus
            menuItems={[
              // {
              //   menu: "Profile",
              //   onClick: () => {
              //     nav("/studentprofile");
              //   },
              // },
              {
                menu: "Logout",
                onClick: () => {
                  sessionStorage.clear();
                  dispatch(clearListuser());
                  dispatch(clearLoginStatus());
                  dispatch(clearDashboardChart());
                  navigate("/login");
                },
              },
            ]}
          >
            <IconButtonField onClick={() => {}}>
              <Avatars sx={{ height: "2rem", width: "2rem" }} />
            </IconButtonField>
          </Menus>
          <span className="Username">{ListUser[0]?.student_name}</span>
        </div>
      </div>

      <Grid container spacing={3}>
        {Mock?.length > 0 ? (
          Mock?.map((card: any) => (
            <Grid item xs={12} sm={12} md={6} lg={3} key={card.id}>
              <Card className={styles.card} sx={{ boxShadow: "none" }}>
                <div
                  style={{
                    position: "relative",
                    display: "inline-block",
                    height: "175px",
                  }}
                >
                  <img
                    src={Mockexamimage}
                    alt="Mock Exam"
                    style={{
                      width: "100%",
                      height: "90%",
                      borderRadius: "10px 10px 0px 0px",
                    }}
                  />

                  {/* <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      background: "#22c55e",
                      color: "#ffff",
                      padding: "1px 7px",
                      borderRadius: "6px",
                      fontSize: "11px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  ></div> */}

                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "10px",
                      background: "#22c55e",
                      color: "#ffff",
                      padding: "1px 7px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      fontWeight: "500",
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    New
                  </div>
                </div>

                <CardContent className={styles.cardBody}>
                  <div className={styles.mockexamname}>{card.exam_name}</div>

                  <Typography
                    variant="body2"
                    className={styles.mockexamndescription}
                    sx={{ minHeight: "4em !important" }}
                  >
                    <p
                      style={{
                        minWidth: 0,
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                        overflowWrap: "anywhere",
                        fontSize: "14px",
                        margin: "0",
                      }}
                    >
                      {card.description}
                    </p>
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      // marginBottom: "8px",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    <div
                      style={{
                        color: "#6b7280",
                        borderRadius: "20px",
                        fontSize: "15px",
                        gap: "3px",
                        display: "flex",
                      }}
                      title={`Question count : ${card?.question_count}`}
                    >
                      <SvgIcon
                        component={document_icon}
                        inheritViewBox
                        sx={{
                          fill: "none",
                          fontSize: "16px",
                          marginTop: "3px",
                        }}
                      />
                      {card?.question_count} questions
                    </div>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginRight: "5px",
                      }}
                    >
                      <AccessTimeIcon
                        fontSize="large"
                        sx={{
                          fontSize: "15px",
                          fontWeight: 600,
                          color: "#6b7280",
                        }}
                      />{" "}
                      <span
                        style={{
                          marginLeft: "4px",
                          fontSize: "15px",
                          color: "#6b7280",
                        }}
                      >
                        {formatDuration(card.total_timing)}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      height: "60px",
                    }}
                  >
                    <Button
                      variant="contained"
                      className={styles.startButton}
                      onClick={() => {
                        dispatch(
                          listInstructionExamID({ exam_id: Mock[0]?.id })
                        );
                        dispatch(
                          addStudentExam({
                            exam_id: Mock[0]?.id,
                            student_id: details?.id,
                            closed: false,
                          })
                        );
                        navigate("/instruction", { state: Mock[0]?.id }); // Replace with your target route
                        dispatch(clearListExamID());
                      }}
                    >
                      Start Now
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Card className={styles.card} sx={{ boxShadow: "none" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                <img
                  src={Mockexamimage}
                  alt="Mock Exam"
                  style={{
                    width: "100%",
                    height: "97%",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                />
              </div>

              <CardContent className={styles.cardBody}>
                <div className={styles.mockexamname}>
                  {" "}
                  No Mock Exams Available
                </div>
                <Typography
                  variant="body2"
                  className={styles.mockexamndescription}
                >
                  Currently, there are no mock exams available at the moment.
                  Please check back soon for updates and new mock exams
                </Typography>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <Button
                    variant="contained"
                    className={styles.startButton}
                    onClick={() => {
                      navigate("/dashboard");
                    }}
                  >
                    Back to home
                  </Button>
                </div>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default MockexamGrid;
